export enum AlignmentOptions {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
  BOTTOM = 'bottom',
  TOP = 'top',
  STRETCH = 'stretch',
}

export enum SlotsAvailability {
  ALL,
  ONLY_AVAILABLE,
}
// Which day the widget opens on for courses (Settings tab > Courses).
export enum CourseLandingDate {
  FIRST_DATE_WITH_SESSIONS = 'FIRST_DATE_WITH_SESSIONS',
  CURRENT_DATE = 'CURRENT_DATE',
}

// Which courses reach the timetable (Settings tab > Courses).
export enum CoursesDisplay {
  ENROLLABLE_ONLY = 'ENROLLABLE_ONLY',
  ALL = 'ALL',
}

// How many sessions of a course are expanded (Settings tab > Courses).
export enum CourseSessionsDisplay {
  LATE_ENROLLMENT_OPEN_ONLY = 'LATE_ENROLLMENT_OPEN_ONLY',
  ALL_SESSIONS = 'ALL_SESSIONS',
  FIRST_SESSION_ONLY = 'FIRST_SESSION_ONLY',
}

export enum FilterType {
  SERVICE = 'SERVICE',
  LOCATION = 'LOCATION',
  STAFF_MEMBER = 'STAFF_MEMBER',
  SERVICE_TYPE = 'SERVICE_TYPE',
  COURSE_STATUS = 'COURSE_STATUS',
}

export type FilterOption = {
  id: string;
  value: string;
  selected: boolean;
};

export type Filter = {
  type: FilterType;
  label: string;
  options: FilterOption[];
};

export enum DisplayStyles {
  UNSET = 'unset',
  NONE = 'none',
}

export enum SettingsTabsTypes {
  Main = 'daily_agenda_widget/main',
  Settings = 'daily_agenda_widget/settings',
  Layout = 'daily_agenda_widget/layout',
  Display = 'daily_agenda_widget/display',
  Design = 'daily_agenda_widget/design',
  Text = 'daily_agenda_widget/text',
}

export enum LayoutTypes {
  LIST = 'LIST',
  SIDE_BY_SIDE = 'SIDE_BY_SIDE',
  OVERLAY = 'OVERLAY',
}
